export const RegisterEmailErrorCodeEnum = {
  EmailAlreadyInUse: 'auth/account-exists-with-different-credential',
  // EmailAlreadyInUse: 'auth/email-already-in-use',
  InvalidEmail: 'auth/invalid-email',
  OperationNotAllowed: 'auth/operation-not-allowed',
  WeakPassword: 'auth/weak-password',
  PasswordsNotMatch: 'auth/do-not-match-passwords',
};


// WEBPACK FOOTER //
// ./src/app/modules/auth/domain/enums/RegisterEmailErrorEnum.ts